// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar_sidebar__\\+Fu2v {
  padding: 12px 0 24px;
  min-height: 100%;
  position: sticky;
  top: 62px;
  height: calc(100vh - 62px);
  width: 334px;
  border-right: 1px solid #E2E2E2;
  flex-shrink: 0;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: 0.3s all;
  z-index: 1;
}
.Sidebar_sidebar__menu__DutFu {
  padding: 0 24px;
}
.Sidebar_sidebar__footer__iCZHu {
  padding: 10px 24px 0;
  width: 100%;
}
.Sidebar_sidebarCollapsed__QQ6\\+s {
  width: 100px;
  overflow: hidden;
}
.Sidebar_sidebarCollapsed__QQ6\\+s .Sidebar_collapse__icon__n41QI > * {
  transform: rotate(180deg);
}
.Sidebar_sidebarCollapsed__QQ6\\+s .Sidebar_collapse__label__7pqTG {
  display: none;
}
.Sidebar_sidebarCollapsed__QQ6\\+s .Sidebar_menuItem__-e2TT {
  position: relative;
}
.Sidebar_sidebarCollapsed__QQ6\\+s .Sidebar_menuItem__label__kGUGU {
  animation: 0.3s Sidebar_hide-label__PhFBA forwards;
}
.Sidebar_sidebarCollapsed__QQ6\\+s .Sidebar_menuItem__icon__gajKT {
  width: 100% !important;
  margin-left: 0 !important;
}

.Sidebar_chats__qkkOq {
  margin-top: 26px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.Sidebar_chats__list__sZIh2 {
  flex-grow: 1;
}
.Sidebar_chats__placeholder__2Isv8 {
  flex-grow: 1;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.Sidebar_chats__search__xD5sP {
  padding: 0 16px 16px 16px;
  display: flex;
  align-items: center;
}
.Sidebar_chats__search__xD5sP > :first-child {
  flex-grow: 1;
  max-width: 100%;
}
.Sidebar_chats__search__xD5sP > * {
  flex-shrink: 0;
}

.Sidebar_collapse__i5tBT {
  width: 100%;
  height: 36px;
  background: #F7F7F7;
  border-radius: 12px;
  border: 0;
  outline: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #8E8E93;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  transition: 0.3s all;
  overflow: hidden;
  -webkit-user-select: none;
          user-select: none;
}
.Sidebar_collapse__icon__n41QI {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 17px;
  height: 100%;
}
.Sidebar_collapse__icon__n41QI > path {
  fill: #8E8E93;
}
.Sidebar_collapse__icon__n41QI > * {
  transform: rotate(0deg);
  transition: 0.3s all;
}

.Sidebar_soundTurn__KzPZ8 {
  background: transparent;
  border: 0;
  outline: none;
  padding: 0 0 0 8px;
  margin-left: 8px;
  cursor: pointer;
}

@keyframes Sidebar_hide-label__PhFBA {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    display: none;
  }
}
@media (max-width: 700px) {
  .Sidebar_sidebar__\\+Fu2v {
    position: fixed;
    left: 0;
    top: 62px;
    width: 100%;
    min-height: 100%;
    z-index: 999;
    background-color: white;
  }
  .Sidebar_sidebar__chats__sqZMX {
    max-height: 400px;
  }
  .Sidebar_sidebar__content__ZVsw2 {
    display: flex;
    flex-direction: column-reverse;
  }
  .Sidebar_invite__T5stt {
    margin-top: 3px;
    margin-bottom: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layouts/HomeLayout/Sidebar/Sidebar.module.scss","webpack://./src/components/layouts/HomeLayout/config.module.scss"],"names":[],"mappings":"AAGA;EACE,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SCJc;EDKd,0BAAA;EACA,YCTc;EDUd,+BAAA;EACA,cAAA;EACA,iBAAA;EAEA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,oBAAA;EACA,UAAA;AAGF;AADE;EACE,eAAA;AAGJ;AAAE;EACE,oBAAA;EACA,WAAA;AAEJ;AACE;EACE,YC7BsB;ED8BtB,gBAAA;AACJ;AAEM;EAGE,yBAAA;AAFR;AAKM;EACE,aAAA;AAHR;AAOI;EACE,kBAAA;AALN;AAOM;EACE,kDAAA;AALR;AAQM;EACE,sBAAA;EACA,yBAAA;AANR;;AAYA;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AATF;AAWE;EACE,YAAA;AATJ;AAYE;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAVJ;AAaE;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;AAXJ;AAaI;EACE,YAAA;EACA,eAAA;AAXN;AAcI;EACE,cAAA;AAZN;;AAiBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EAEA,SAAA;EACA,aAAA;EAEA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,eAAA;EAEA,aAAA;EACA,2BAAA;EACA,mBAAA;EAEA,oBAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;AAnBF;AAqBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAnBJ;AAqBI;EACE,aAAA;AAnBN;AAsBI;EACE,uBAAA;EACA,oBAAA;AApBN;;AAyBA;EACE,uBAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAtBF;;AAyBA;EACE;IACE,UAAA;EAtBF;EAyBA;IACE,UAAA;IACA,aAAA;EAvBF;AACF;AA0BA;EACE;IACE,eAAA;IACA,OAAA;IACA,SC/JY;IDgKZ,WAAA;IACA,gBAAA;IAGA,YAAA;IACA,uBAAA;EA1BF;EA4BE;IACE,iBAAA;EA1BJ;EA+BE;IACE,aAAA;IACA,8BAAA;EA7BJ;EAiCA;IACE,eAAA;IACA,mBAAA;EA/BF;AACF","sourcesContent":["@import '../config.module';\n@import '@/assets/scss/mixins.scss';\n\n.sidebar {\n  padding: 12px 0 24px;\n  min-height: 100%;\n  position: sticky;\n  top: $header-height;\n  height: calc(100vh - #{$header-height});\n  width: $sidebar-width;\n  border-right: 1px solid #E2E2E2;\n  flex-shrink: 0;\n  background: white;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  transition: 0.3s all;\n  z-index: 1;\n\n  &__menu {\n    padding: 0 24px;\n  }\n\n  &__footer {\n    padding: 10px 24px 0;\n    width: 100%;\n  }\n\n  &Collapsed {\n    width: $sidebar-collapsed-width;\n    overflow: hidden;\n\n    .collapse {\n      &__icon > * {\n        //width: 70px;\n        //margin-left: 10px;\n        transform: rotate(180deg);\n      }\n\n      &__label {\n        display: none;\n      }\n    }\n\n    .menuItem {\n      position: relative;\n\n      &__label {\n        animation: 0.3s hide-label forwards;\n      }\n\n      &__icon {\n        width: 100% !important;\n        margin-left: 0 !important;\n      }\n    }\n  }\n}\n\n.chats {\n  margin-top: 26px;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n\n  &__list {\n    flex-grow: 1;\n  }\n\n  &__placeholder {\n    flex-grow: 1;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &__search {\n    padding: 0 16px 16px 16px;\n    display: flex;\n    align-items: center;\n\n    &>:first-child {\n      flex-grow: 1;\n      max-width: 100%;\n    }\n\n    &>* {\n      flex-shrink: 0;\n    }\n  }\n}\n\n.collapse {\n  width: 100%;\n  height: 36px;\n  background: #F7F7F7;\n  border-radius: 12px;\n\n  border: 0;\n  outline: none;\n\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n  color: #8E8E93;\n\n  cursor: pointer;\n\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  transition: 0.3s all;\n  overflow: hidden;\n  user-select: none;\n\n  &__icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0 17px;\n    height: 100%;\n\n    & > path {\n      fill: #8E8E93;\n    }\n\n    & > * {\n      transform: rotate(0deg);\n      transition: 0.3s all;\n    }\n  }\n}\n\n.soundTurn {\n  background: transparent;\n  border: 0;\n  outline: none;\n  padding: 0 0 0 8px;\n  margin-left: 8px;\n  cursor: pointer;\n}\n\n@keyframes hide-label {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    display: none;\n  }\n}\n\n@media(max-width: $mobile-sidebar-breakpoint-width) {\n  .sidebar {\n    position: fixed;\n    left: 0;\n    top: $header-height;\n    width: 100%;\n    min-height: 100%;\n    //display: none;\n\n    z-index: 999;\n    background-color: white;\n\n    &__chats {\n      max-height: 400px;\n    }\n    //padding-left: 16px;\n    //padding-right: 16px;\n\n    &__content {\n      display: flex;\n      flex-direction: column-reverse;\n    }\n  }\n\n  .invite {\n    margin-top: 3px;\n    margin-bottom: 16px;\n  }\n}\n","$sidebar-width: 334px;\n$sidebar-collapsed-width: 100px;\n\n$header-height: 62px;\n\n\n// max width on which should be visible mobile sidebar\n$mobile-sidebar-breakpoint-width: 700px;\n\n:export {\n  sidebarWidth: $sidebar-width;\n  sidebarWidthCollapsed: $sidebar-collapsed-width;\n\n  mobileSidebarBreakpointWidth: $mobile-sidebar-breakpoint-width;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebarWidth": `334px`,
	"sidebarWidthCollapsed": `100px`,
	"mobileSidebarBreakpointWidth": `700px`,
	"sidebar": `Sidebar_sidebar__+Fu2v`,
	"sidebar__menu": `Sidebar_sidebar__menu__DutFu`,
	"sidebar__footer": `Sidebar_sidebar__footer__iCZHu`,
	"sidebarCollapsed": `Sidebar_sidebarCollapsed__QQ6+s`,
	"collapse__icon": `Sidebar_collapse__icon__n41QI`,
	"collapse__label": `Sidebar_collapse__label__7pqTG`,
	"menuItem": `Sidebar_menuItem__-e2TT`,
	"menuItem__label": `Sidebar_menuItem__label__kGUGU`,
	"hide-label": `Sidebar_hide-label__PhFBA`,
	"menuItem__icon": `Sidebar_menuItem__icon__gajKT`,
	"chats": `Sidebar_chats__qkkOq`,
	"chats__list": `Sidebar_chats__list__sZIh2`,
	"chats__placeholder": `Sidebar_chats__placeholder__2Isv8`,
	"chats__search": `Sidebar_chats__search__xD5sP`,
	"collapse": `Sidebar_collapse__i5tBT`,
	"soundTurn": `Sidebar_soundTurn__KzPZ8`,
	"sidebar__chats": `Sidebar_sidebar__chats__sqZMX`,
	"sidebar__content": `Sidebar_sidebar__content__ZVsw2`,
	"invite": `Sidebar_invite__T5stt`
};
export default ___CSS_LOADER_EXPORT___;
